import React from "react";
import Input from "./Input";
import { RewardType, ValidationType } from "../../types";
import { StoreFunctions } from "../context/Store";

export interface RewardsProps {
  temp: RewardType;
  onChange: StoreFunctions["setTempReward"];
  validation: ValidationType<RewardType>;
}

export interface RewardsState {}

export const Rewards = (props: RewardsProps) => {
  const { temp, onChange, validation } = props;
  const { name, company, description, date } = temp;
  const change = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.name as keyof RewardType, e.target.value);
  };
  return (
    <>
      <div className="row">
        <div className="col-12 col-sm-6">
          <Input
            name="name"
            label="Nazwa nagrody / wyróżnienia"
            onChange={change}
            value={name}
            required={validation.name.required}
            isValid={validation.name.valid(name)}
            id="rewardName"
          />
        </div>
        <div className="col-12 col-sm-6">
          <Input
            name="company"
            label="Firma / instytucja"
            onChange={change}
            value={company}
            required={validation.company.required}
            isValid={validation.company.valid(company)}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <Input
            name="description"
            label="Krótki opis"
            onChange={change}
            value={description}
            required={validation.description.required}
            isValid={validation.description.valid(description)}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-6 col-sm-5">
          <Input
            name="date"
            label="Data"
            onChange={change}
            value={date}
            required={validation.date.required}
            isValid={validation.date.valid(date)}
            type="text"
          />
        </div>
      </div>
    </>
  );
};

export default Rewards;
